import React from 'react';
import PropTypes from 'prop-types';

import withModal from '../../../../../../components/global/modal/withModal';
import MarketingMaterialAssetConfigurator from './MarketingMaterialAssetConfigurator';

export const MARKETING_MATERIAL_ASSET_CONFIGURATOR_MODAL =
  'modal/MARKETING_MATERIAL_ASSET_CONFIGURATOR_MODAL';

const propTypes = {
  actionProps: PropTypes.shape({
    label: PropTypes.string,
    marketingMaterialType: PropTypes.string,
    albumFolder: PropTypes.shape({
      id: PropTypes.string,
    }),
  }),
  onRequestClose: PropTypes.func,
  onDesignSaved: PropTypes.func.isRequired,
  onDesignRemoved: PropTypes.func.isRequired,
};

const MarketingMaterialAssetConfiguratorModal = ({
  actionProps: { label, marketingMaterialType, albumFolder } = {},
  onRequestClose,
  ...props
}) => (
  <MarketingMaterialAssetConfigurator
    label={label}
    marketingMaterialType={marketingMaterialType}
    albumFolder={albumFolder}
    onClose={onRequestClose}
    {...props}
  />
);

MarketingMaterialAssetConfiguratorModal.propTypes = propTypes;

export default withModal(MarketingMaterialAssetConfiguratorModal, {
  name: MARKETING_MATERIAL_ASSET_CONFIGURATOR_MODAL,
  dismissible: false,
  type: 'full',
  hideHeader: true,
  size: 'md',
});
